import type { LaidOutNode } from "../../lib/topology";

export function Node({ node }: { node: LaidOutNode }) {
  const stroke =
    node.state === "active" ? "var(--color-secondary)" :
    node.state === "failure" ? "var(--color-text-secondary)" :
    "var(--color-border)";
  const strokeDasharray = node.state === "failure" ? "3 2" : undefined;
  return (
    <g className="topology-node">
      <circle cx={node.x} cy={node.y} r="10" fill="var(--color-surface)" stroke={stroke} strokeWidth="1.2" strokeDasharray={strokeDasharray} />
      <circle cx={node.x} cy={node.y} r="3" fill={node.state === "active" ? "var(--color-text-accent)" : "var(--color-text-secondary)"} />
      {node.label ? (
        <text x={node.x} y={node.y + 24} fontFamily="var(--font-mono)" fontSize="10" fill="var(--color-text-secondary)" textAnchor="middle">
          {node.label}
        </text>
      ) : null}
    </g>
  );
}
